<p-calendar
  styleClass="pp-cal"
  [placeholder]="placeholder"
  [showIcon]="showIcon"
  [dateFormat]="dateFormat"
  [selectionMode]="selectionMode"
  [showTime]="showTime"
  [disabled]="disabled"
  [ngModel]="value"
  (ngModelChange)="onValueChange($event)"
  (onBlur)="onBlur()"
  appendTo="body">
</p-calendar>
